import * as PropertyBucket from '../../Properties/Properties.js';
import * as httpService from '../../Components/HttpService/HttpService';

export function getPublicOrdersDataRequested() {
    return {
        type: 'GET_PUBLIC_ORDERS_DATA_REQUESTED'
    };
}

export function getPublicOrdersDataDone(data) {
    return {
        type: 'GET_PUBLIC_ORDERS_DATA_DONE',
        orders: data.publicOrders,
        count: data.count
    };
}

export function getPublicOrdersDataFailed(error) {
    return {
        type: 'GET_PUBLIC_ORDERS_DATA_FAILED',
        payload: error
    };
}

export function getPublicOrdersData(projectId, pageSize, pageNumber, filters, sorting) {

    const url = PropertyBucket.getPublicOrders(projectId, pageSize, pageNumber);

    const sortingField = sorting.index === 1 ? 'announcementName' : 'announcementNumber'

    const filtersDefinition = [{property: "status", value: "2", condition: "Multiselect"}, ...filters]

    const payload = {filters: filtersDefinition, sortingField: sortingField, isDesc: sorting.direction === 'desc'};

    return dispatch => {
        dispatch(getPublicOrdersDataRequested());
        let response = httpService.getServicePromise(url, "POST", payload);
            response.then(data => {
                dispatch(getPublicOrdersDataDone(data));
            })
            .catch(error => {
                dispatch(getPublicOrdersDataFailed(error));
            })
    }
}


export const GET_PUBLIC_ORDERS_DATA_REQUESTED = 'GET_PUBLIC_ORDERS_DATA_REQUESTED';
export const GET_PUBLIC_ORDERS_DATA_DONE = 'GET_PUBLIC_ORDERS_DATA_DONE';
export const GET_PUBLIC_ORDERS_DATA_FAILED = 'GET_PUBLIC_ORDERS_DATA_FAILED';